import cx from 'classnames';
import config from '@plone/volto/registry';
import { useIntl, defineMessages } from 'react-intl';

import styles from './styles.module.css';
import { queryData } from '../../Slots/BlogHomepage/BlogHomepage';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import {
  getAppendedResultsQuery,
  resetGetAppendedResults,
} from '@redturtle/qubicaamf-theme/actions/getAppendedResultsQuery';
import { useAppendedResults } from '@redturtle/qubicaamf-theme/helpers/hooks/useAppendedResults.hook';
import MasonryTemplate from '../../commons/Masonry/MasonryTemplate';
import { Link } from 'react-router-dom';

interface ContentByTagProps {
  location: {
    hash: string;
    pathname: string;
    search: string;
    state: string;
  };
}

const ContentByTag = (props: ContentByTagProps) => {
  const intl = useIntl();
  const { location } = props;
  const dispatch = useDispatch();
  const Container = config.getComponent('Container').component || 'div';

  const params = new URLSearchParams(location.search);
  const cameFrom = params.get('cameFrom');

  const tagName = params.get('name');
  const adaptedQueryData = {
    ...queryData,
    blog_tags: [tagName],
  };

  useEffect(() => {
    dispatch(
      getAppendedResultsQuery(
        '/',
        { ...adaptedQueryData, b_start: 0 },
        location.pathname,
        false,
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const data = useAppendedResults();

  const subrequestResults = data.subrequests[location.pathname];

  const loadMore = () => {
    dispatch(
      getAppendedResultsQuery(
        '/',
        { ...adaptedQueryData, b_start: subrequestResults.items.length },
        location.pathname,
        true,
      ),
    );
  };

  useEffect(() => {
    resetGetAppendedResults(location.pathname);
  }, [location.pathname]);

  return (
    <div className={cx('has--fullwidth--true has--bg--gray', styles.view)}>
      <Container>
        <div className={styles.backLink}>
          <Icon name="arrow left" />
          <Link to={cameFrom ? cameFrom : '/news'}>
            {intl.formatMessage(messages.back)}
          </Link>
        </div>
        <h1 className={styles.title}>{tagName}</h1>
        {subrequestResults?.items.length > 0 && (
          <MasonryTemplate
            key={tagName}
            items={subrequestResults.items}
            loading={subrequestResults.loading}
            totalItems={subrequestResults.total}
            loadMore={loadMore}
          />
        )}
      </Container>
    </div>
  );
};

export default ContentByTag;

const messages = defineMessages({
  back: {
    id: 'back',
    defaultMessage: 'Back',
  },
});
